<div style="padding-bottom: 16px;">

    @let _showError = displayError();

    <div class="webservice-section" [class.error]="_showError != null && _showError">

        @if (_showError == null) {
            <div>
                Carregant la informació...
            </div>
        }
        @else if (_showError) {

            <div class="d-flex flex-column justify-content-center">
                <div class="eac-body-2 valign-center" style="min-height: 36px; width: 80%;">
                    {{metadata().titleError}}
                </div>
                <div class="valign-center eac-c1">
                    <quill-view-html [content]="metadata().descriptionError"></quill-view-html>
                </div>
            </div>

        }
        @else {

            <div class="d-flex flex-column justify-content-center">

                @if(metadata().name) {
                    <div class="eac-body-2 valign-center" style="min-height: 36px; width: 80%;">
                        {{metadata().name}}
                    </div>
                }

                @if(metadata().description) {
                    <div class="valign-center eac-c1">
                        <quill-view-html [content]="metadata().description"></quill-view-html>
                    </div>
                }

            </div>

            <div *ngFor="let field of field.fieldGroup; let i = index;" class="row2 ">
                <div class="col-sm-12">
                    <div style="padding-top: 16px;">
                        <formly-field [field]="field"></formly-field>
                    </div>
                </div>
            </div>
        }

    </div>

</div>